<template lang="pug">
a.text-xs.font-mono.cursor-pointer.transition-colors.duration-400.ease-in-out(:class="textColor", @click="copyId(id)", @keyup.enter="copyId(id)")
  | # {{ id }}
</template>
<script>
export default {
  data() {
    return {
      copied: false,
      copyTimer: null,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    textColor() {
      return `${this.copied ? 'text-blue-500' : 'text-gray-400'}`;
    },
  },
  methods: {
    copyId(id) {
      navigator.clipboard.writeText(id);
      this.copied = true;
      this.copyTimer = setTimeout(() => {
        this.copied = false;
      }, 500);
    },
  },
  beforeDestroy() {
    clearTimeout(this.copyTimer);
  },
};
</script>
